import RegisterForm from '../components/Landing/RegisterForm';
import Navbar from '../components/Landing/Navbar';
import Landing from '../components/Landing/Landing';

const Register = () => {
    return (
        <div className="page-landing">
            <Navbar />
            <div className="subpage-landing">
                <div className="section-landing">
                    <Landing />
                </div>
                <div className="section-registration">
                    <RegisterForm />
                </div>
            </div>
        </div>
    );
};

export default Register;
